import { RemoteDeleteAuditReportItem } from 'data/usecases/remote-delete-audit-report-item';
import { makeApiUrl } from '../http';
import { makeAuthorizeHttpClientDecorator } from '../decorators';
import { DeleteAuditReportItem } from 'domain/usecases/delete-audit-report-item';

export const makeRemoteDeleteAuditReportItem = (): DeleteAuditReportItem => {
  return new RemoteDeleteAuditReportItem(makeApiUrl('/dismissDataAuditResults'), makeAuthorizeHttpClientDecorator());
};
